import React from "react";

function UserHomePage() {
  return <div>home</div>;
}

export default UserHomePage;
